type ProjectCreationError = {
  isNameEmpty: boolean;
  isDateRangeInvalid: boolean;
  isStartDateInvalid: boolean;
  isEndDateInvalid: boolean;
  hasUnExpectedError: boolean;
  message: string;
};

const projectCreationError: ProjectCreationError = {
  isNameEmpty: false,
  isDateRangeInvalid: false,
  isStartDateInvalid: false,
  isEndDateInvalid: false,
  hasUnExpectedError: false,
  message: "",
};

export type { ProjectCreationError };

export { projectCreationError };
